import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import AdminLayout from "../layout/AdminLayout";
import { authName } from "../utils/config";
import Loading from "../components/Loading";

const PrivateRoutes: React.FC = () => {
  const [isAuth, setIsAuth] = useState<boolean | null>(null);

  useEffect(() => {
    const authStatus = Boolean(window.localStorage.getItem(authName));
    setIsAuth(authStatus);
  }, []);

  if (isAuth === null) {
    return <Loading/>; 
  }

  return isAuth ? (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  ) : (
    <Navigate to="/login" replace />
  );
};

export default PrivateRoutes;
